import {createEntityStore} from "base/entity/repository";
import {createCartoCiudadSearchAdapter} from "base/geo/cartociudad/repository";

const adapter = createCartoCiudadSearchAdapter();

const store = createEntityStore({
    adapter,
});

const LocationRepository = {
    getList(filter = {}) {
        return store.getList(filter);
    },

    get(id, type) {
        // TODO (egago): This method call should be done using the store (but not an Entity Store)
        return adapter.find(id, type);
    },
};

export default LocationRepository;
